import { apiErrorMessages } from './api-error';

export class ErrorHandler {
  /**
   * Generic error handling method to process API errors and display notifications.
   * @param err The error object from the API response.
   * @param notify The notification service to display messages (must have showWarning and showError methods).
   * @param resendCode Optional callback function to trigger when "Email is not verified" is encountered.
   * @param defaultErrorMessage Optional custom default error message.
   * @param context What the request was doing, shown in front of the API's reason ("Couldn't load fees: ...").
   * @returns Boolean indicating if a specific error (e.g., "Email is not verified") was handled.
   */
  static handleError(
    err: any,
    notify: { showWarning: (message: string, title: string) => void; showError: (message: string, title: string) => void },
    resendCode?: () => void,
    defaultErrorMessage: string = 'An unexpected error occurred',
    context?: string
  ): boolean {
    const messages = apiErrorMessages(err);
    // The login form reports an unverified email as `username: ['Email is not verified']`
    const emailNotVerifiedFound = messages.some((message) => message.endsWith('Email is not verified'));
    if (emailNotVerifiedFound) {
      notify.showWarning('Email is not verified', 'Warning');
      if (resendCode) {
        resendCode();
      }
    } else {
      const reason = messages.length ? messages.join('\n') : defaultErrorMessage;
      notify.showError(context ? `${context}: ${reason}` : reason, 'Error');
    }

    return emailNotVerifiedFound;
  }
}
